import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import PoLinkStatus from "@/components/customers/PoLinkStatus";
import { countryName, isForeignCountry } from "@/lib/countries";
import type { CustomerDetail } from "@/hooks/use-customer-detail";

interface CustomerInfoCardProps {
  customer: CustomerDetail;
}

/**
 * Kundeinfo: org.nr, land, kontaktfelt og faktura-e-post. Brukes bare når
 * feature_crm_kundekort er av; kundekort v2 har dette bak «Rediger» i heroen.
 */
export default function CustomerInfoCard({ customer }: CustomerInfoCardProps) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <Card>
        <CardHeader><CardTitle className="text-base">Kundeinfo</CardTitle></CardHeader>
        <CardContent className="space-y-2 text-sm">
          <PoLinkStatus customerId={customer.id} poCustomerId={customer.poweroffice_customer_id} />
          <div className="flex justify-between"><span className="text-muted-foreground">Org.nr</span><span>{customer.organization_number || '-'}</span></div>
          {isForeignCountry(customer.country_code) && (
            <div className="flex justify-between"><span className="text-muted-foreground">Land</span><span>{countryName(customer.country_code)}</span></div>
          )}
          <div className="flex justify-between"><span className="text-muted-foreground">Kontaktperson</span><span>{customer.contact_person || '-'}</span></div>
          <div className="flex justify-between"><span className="text-muted-foreground">E-post</span><span>{customer.contact_email || '-'}</span></div>
          <div className="flex justify-between"><span className="text-muted-foreground">Telefon</span><span>{customer.contact_phone || '-'}</span></div>
          {/*
            VIB-2521: faktura-e-post er PO sitt InvoiceEmailAddress, et annet
            felt enn kontakt-e-posten. Det er hit fakturaen sendes når
            prosjektet ikke overstyrer, så det må være synlig for seg selv.
          */}
          <div className="flex justify-between border-t pt-2 mt-2">
            <span className="text-muted-foreground">Faktura-e-post</span>
            <span>{customer.invoice_email_address || '-'}</span>
          </div>
          {customer.invoice_email_cc && (
            <div className="flex justify-between">
              <span className="text-muted-foreground">Faktura-kopi</span>
              <span>{customer.invoice_email_cc}</span>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
